<template>
    <main>
      <captive-forms-list :infinite-id="infiniteId"
                            @reload="reload" />
    </main>
  </template>
  
  <script>
  import CaptiveFormsList from "@components/modules/captive-forms/list/CaptiveFormsList.vue";
  
  export default {
    components: {
      CaptiveFormsList
    },
  
    data() {
      return {
        infiniteId: +new Date(),
      };
    },
    mixins: [],
  
    props: {}, 
      
    methods: {
      async reload() {
        this.infiniteId++;
      },
    },
  
    computed: {},
  };
  </script>
  
  <style lang="scss" scoped>
  </style>